module.exports = __webpack_public_path__ + "static/media/agroart.7559d40a.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Shop/assets/screenshots/lite/agroart.png
// module id = 831
// module chunks = 20